<template>
    <div>
        <!-- Schema.org metatags for images -->
        <meta itemprop="url" :content='location'/>
        <meta v-for='image in object.images'
            v-if='image.media_type == "Images"'
            itemprop="image"
            :content='createPath(image.path)'/>

        <!-- Twitter Card data -->
        <meta name="twitter:card" value="summary_large_image">
        <meta name="twitter:site" content="@MarinersMuseum">
        <meta name="twitter:title" :content="object.searchable.title[0]">
        <meta name="twitter:url" :content='location'>
        <meta name="twitter:description" :content='object.description'>
        <meta name="twitter:image:src" :content='firstImage(object.images)'>

        <!-- Facebook Open Graph Metadata -->
        <meta property="og:title" :content="object.searchable.title[0]">
        <meta property="og:type" content="website">
        <meta property="og:site_name" content="The Mariners' Museum Online Catalog">
        <meta property="og:description" :content='object.description'>
        <meta property="og:image" :content='firstImage(object.images)'>
        <meta property="og:url" :content='location'>
    </div>
</template>


<script>
    export default {
        props: ['object'],
        data: function () {
            return {
                location: window.location.href
            }
        },
        methods: {
            firstImage: function (images) {
                var image = null;
                images.forEach(function (media) {
                    if (image == null && media.media_type == "Images") {
                        image = media
                    }
                })

                if (image) {
                    return this.createPath(image.path);
                }

                return null;
            },
            createPath: function (url) {
                return window.location.origin + '/media/' + url;
            },
        }
    }
</script>
